import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { Helpers } from '../../../helpers';

declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {


    constructor(private _script: ScriptLoaderService) { }
    ngOnInit() {

    }
    ngAfterViewInit() {

        mLayout.initAside();
        this._script.loadScripts('app-inner',
            ['/assets/js/main.js']);
    }

}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/main/layouts/aside-nav/aside-nav.component.ts